import React, { Component } from "react";
import { connect } from "react-redux";
import { Field, reduxForm } from "redux-form";
import { BlueBtn } from "components/Controls";
import { TextField } from "components/Fields";
import { required, isNumEqual4 } from "utils/validations";
import { onlyNumbers } from "utils/normalize";
import { tokenSelector } from "containers/EmbeddableWidget/selectors";
import { createStructuredSelector } from "reselect";
import { nextStep, setPrequalData } from "../actions";
import { appRequestSelector } from "../selectors";
import { ProvidersApi } from "api/providers";
import RightArrow from "assets/img/icon-arrow-right.svg";
import "./styles.scss";

class ProgressiveCustomerLookup extends Component {
  state = {
    loading: false,
  };

  submitForm = (values) => {
    const { token, appRequest, nextStep, setPrequalData } = this.props;
    this.setState({ loading: true });

    const lookupData = {
      phone: appRequest.personalInfo.phone,
      last4_ssn: onlyNumbers(values.ssnLast4),
      cart_zip: appRequest.residenceInfo?.zip || appRequest.zip,
      items: appRequest.items,
      orderId: appRequest.orderId,
      shipping: appRequest.shipping,
    };

    ProvidersApi.progressivePrequalLookup(token, lookupData)
      .then((data) => {
        this.setState({ loading: false });

        if (data.status === 'prequalified' || data.status === 'approved') {
          const cartTotal = (appRequest.items || []).reduce(
            (sum, item) => sum + (item.price || 0) * (item.quantity || 1), 0
          );

          const dataWithCartTotal = { ...data, cart_total: cartTotal, lookup: lookupData };
          setPrequalData(dataWithCartTotal);

          const approvalLimit = data.approval_amount_with_buffer || data.approval_amount;
          if (approvalLimit && cartTotal > approvalLimit) {
            nextStep({ step: 'progressivePrequalPartial', data: dataWithCartTotal });
            return;
          }

          if (data.status === 'prequalified') {
            nextStep({ step: 'progressivePrequalOffer', data: dataWithCartTotal });
          } else {
            nextStep({ step: 'progressivePrequalApproved', data: dataWithCartTotal });
          }
        } else {
          nextStep({ step: 'form2' });
        }
      })
      .catch(() => {
        this.setState({ loading: false });
        nextStep({ step: 'form2' });
      });
  };

  renderSSNField = ({ input, meta }) => {
    return (
      <TextField
        label="* Last 4 digits of SSN"
        placeholder="1234"
        meta={meta}
        type="tel"
        maxLength="4"
        {...input}
      />
    );
  };

  render() {
    const { handleSubmit, valid } = this.props;
    const { loading } = this.state;

    return (
      <div className="progressive-customer-lookup">
        <div className="phone-confirmation_block">
          <div className="phone-confirmation_title">
            Just One More Step
          </div>
          <div className="phone-confirmation_text">
            Enter the last 4 digits of your SSN
          </div>
        </div>

        <div className="step1-form-advantages">
          <form onSubmit={handleSubmit(this.submitForm)} className="step1__form paypair-form">
            <div>
              <Field
                name="ssnLast4"
                component={this.renderSSNField}
                validate={[required, isNumEqual4]}
                normalize={onlyNumbers}
              />
            </div>

            <BlueBtn
              customClass="custom-height-button"
              loading={loading}
              disabled={!valid || loading}
              type="submit"
            >
              Continue
              <img src={RightArrow} className="icon-arrow-right" alt="right-arrow" />
            </BlueBtn>
          </form>
        </div>
      </div>
    );
  }
}

const mapStateToProps = createStructuredSelector({
  token: tokenSelector(),
  appRequest: appRequestSelector(),
});

const mapDispatchToProps = (dispatch) => {
  return {
    nextStep: (data) => dispatch(nextStep(data)),
    setPrequalData: (data) => dispatch(setPrequalData(data)),
  };
};

ProgressiveCustomerLookup = connect(
  mapStateToProps,
  mapDispatchToProps
)(ProgressiveCustomerLookup);

ProgressiveCustomerLookup = reduxForm({
  form: "progressiveLookupForm",
  destroyOnUnmount: false,
})(ProgressiveCustomerLookup);

export default ProgressiveCustomerLookup;